import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';

/**
 * Component responsible for displaying course description
 * Follows Single Responsibility Principle - only handles description display
 */
@Component({
  selector: 'app-course-description-card',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './course-description-card.component.html',
  styleUrl: './course-description-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CourseDescriptionCardComponent {
  course = input<ChallengeGen.Course | undefined>(undefined);
}
